import React from 'react';
import './CheckOut.css';

const CheckOut = () => (
  
<div>

</div>
)
export default CheckOut;